import React from "react";
import FormatHeaderTabName from "./FormatHeaderTabName";
import { BullseyeAlertsModal } from "dashboard/_root/components/BullseyeAlertsModal/BullseyeAlertsModal";

function FormatHeader({
  column,
  i,
  index,
  setRefreshKiss,
  tooltips,
  hover,
  setHover,
  fetchPanels,
  planInterval,
  header30DTotal,
  header90DTotal,
  headerVolatilityTotal,
  headerRealizedVolatilityTotal,
  kiss,
  updatedDate,
  setLoading,
}) {
  const [columnsModal, setColumnsModal] = React.useState(false);

  const result = [
    "S/T Momentum Signal",
    "S/T Momentum Price",
    "M/T Momentum Signal",
    "M/T Momentum Price",
  ].includes(column.Header)
    ? [column.Header]
    : column.Header.split("/");

  if (i === 0) {
    return (
      <FormatHeaderTabName
        column={column}
        index={index}
        setRefreshKiss={setRefreshKiss}
        hover={hover}
        setHover={setHover}
        fetchPanels={fetchPanels}
        columnsModal={columnsModal}
        setColumnsModal={setColumnsModal}
        tooltips={tooltips}
        setLoading={setLoading}
        kiss={kiss}
        header30DTotal={header30DTotal}
        header90DTotal={header90DTotal}
      />
    );
  } else if (result[0] === "Closing Price") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{ fontWeight: 100, color: "#bbb8b8" }}
        >{`Closing\nPrice`}</div>
        <div
          data-tip={`The closing price of a security for the prior trading day.`}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 8,
            marginBottom: 2,
            marginRight: -15,
            position: "relative",
            left: -9,
            bottom: 1.5,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Last Price") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Last\nPrice`}</div>
        <div
          data-tip={
            planInterval === "intraday" || planInterval === "daily"
              ? `The most recent price of a security captured by Longbow.`
              : `To get Intraday updates, upgrade your subscription in the Account > Manage Subscriptions.`
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 8,
            marginBottom: 2,
            marginRight: -15,
            position: "relative",
            left: -5,
            bottom: 1.5,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Long Short") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{ fontWeight: 100, color: "#bbb8b8" }}
        >{`Long/\nShort`}</div>
        <div
          data-tip={`Long/Short data`}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 8,
            marginBottom: 2,
            marginRight: -15,
            position: "relative",
            left: -5,
            bottom: 1.5,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Entry Date") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Entry\nDate`}</div>
        <div
          data-tip={`Entry Date data`}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 8,
            marginBottom: 2,
            marginRight: -15,
            position: "relative",
            left: -5,
            bottom: 1.5,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Entry Price") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{ fontWeight: 100, color: "#bbb8b8" }}
        >{`Entry\nPrice`}</div>
        <div
          data-tip={`Entry Price data`}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 8,
            marginBottom: 2,
            marginRight: -15,
            position: "relative",
            left: -5,
            bottom: 1.5,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Set Alerts") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Set\nAlerts`}</div>
      </div>
    );
  } else if (result[0] === "Signal") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{ fontWeight: 100, color: "#bbb8b8" }}
        >{`Core\nSignal`}</div>
        <div
          data-tip={
            "Longbow's proprietary Core Signal is the summation of key trading statistics and thresholds, including but not limited to the Trading Range Signal, that provides an overall, consolidated actionable signal of Buy/Sell/Hold."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 2,
            marginRight: -15,
            bottom: 1.5,
            position: "relative",
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Signal Strength") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
          marginRight: 20,
        }}
      >
        <div
          style={{ fontWeight: 100, color: "#bbb8b8" }}
        >{`\nSignal\nStrength`}</div>
        <div
          data-tip={"An estimate of the strength behind the Core Signal."}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 2,
            marginRight: -15,
            position: "relative",
            bottom: 1.5,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Range") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Range\nView`}</div>
      </div>
    );
  } else if (result[0] === "Low") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            fontWeight: 100,
            color: "#bbb8b8",
            marginRight: -10,
            marginLeft: -10,
            textAlign: "left",
            marginTop: -100,
          }}
        >{`Buy\nBelow`}</div>
        <div
          data-tip={
            "The low price of the daily trading range for a security, as defined by the Bullseye AI trading algorithm."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            bottom: 32,
            right: 8,
            position: "absolute",
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "High") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            fontWeight: 100,
            color: "#bbb8b8",
            marginRight: -10,
            marginLeft: -10,
            textAlign: "left",
          }}
        >{`Sell\nAbove`}</div>
        <div
          data-tip={
            "The high price of the daily trading range for a security, as defined by the Bullseye AI trading algorithm."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            bottom: 32,
            right: 8,
            position: "absolute",
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Odds") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Odds</div>
        <div
          data-tip={
            "Odds represents the numerical comparison of the two key Algo Range variables: the % from the low and the % from the high.  The numerator depends on which has the greatest potential move and the ratio’s sign depends on which figure is the greatest on an absolute basis."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 5,
            marginBottom: 1,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Range Signal") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
          marginLeft: -5,
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>
          {"Range\nSignal"}
        </div>
        <div
          data-tip={
            "The Algo Signal is based on a security’s price relative to the low and high prices defined by the Bullseye AI trading algorithm. The signal shows GREEN if the last price of the security is trading at or below the daily trading range.  The signal shows GREY if the last price of the security is trading within the trading range.  The signal shows RED if the last price of the security is trading at or above the daily trading range."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Asymmetry") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Asymmetry</div>
        <div
          data-tip={
            "Bullish when the asymmetry of a security's price is to the upside in comparison to both boundaries of the trading range, and bearish when the asymmetry is to the downside."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "Low End") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>
          {"Low End\nof the TR"}
        </div>
        <div
          data-tip={
            "The Low End Signal states whether the current Low End of the Trading Range is Higher, Neutral, or Lower than the Low End of the Trading Range on the prior trading day."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "High End") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>
          {"High End\nof the TR"}
        </div>
        <div
          data-tip={
            "The High End Signal states whether the current High End of the Trading Range is Higher, Neutral, or Lower than the High End of the Trading Range on the prior trading day."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (
    result[0] === "<30D Momentum" ||
    (result[0] === "S/T Momentum Signal" &&
      localStorage.getItem("view") === "basic")
  ) {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div>
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Short Term</div>
          <div
            style={{ fontWeight: 100, color: "#bbb8b8" }}
          >{`<30 Days     `}</div>
        </div>
        <div
          data-tip={
            "The Short Term Momentum Signal reflects how a security's price has been trading on a short-term basis (30 days or less)."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -10,
            marginLeft: -10,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "<30D 3D Momentum") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div>
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>3D</div>
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Momentum</div>
        </div>
        <div
          data-tip={"The Short Term Momentum Signal from 3 days ago"}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "<30D IVOL Premium") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div>
          <div
            style={{ fontWeight: 100, color: "#bbb8b8" }}
          >{`Premium\n(Discount)`}</div>
        </div>
        <div
          data-tip={
            "Longbow's Implied Volatility Premium/(Discount) Signal summarizes a key volatility relationship to identify when market participants' expectation for a security's price volatility is reflected by Greed, Fear or a Neutral stance.  Longbow uses proprietary thresholds for the quotient of: (i)30 Day Implied Volatility divided by (ii) 30 Day Realized Volatility -1"
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === "<30D 1W IVOL Premium") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div>
          <div
            style={{ fontWeight: 100, color: "#bbb8b8" }}
          >{`-1W Premium /\n(Discount)`}</div>
        </div>
        <div
          data-tip={
            "The quotient of: (i) a security's 30 Day Implied Volatility from 1 week ago,  divided by (ii) a security's 30 Day Realized Volatility from 1 week ago, minus 1"
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (
    result[0] === ">90D Momentum" ||
    (result[0] === "M/T Momentum Signal" &&
      localStorage.getItem("view") === "basic")
  ) {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
          marginLeft: -10,
        }}
      >
        <div>
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Medium Term</div>
          <div
            style={{ fontWeight: 100, color: "#bbb8b8" }}
          >{`<120 Days     `}</div>
        </div>
        <div
          data-tip={
            "The Medium Term Momentum Signal reflects how a security's price has been trading on a medium-term basis (less than 120 days)."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -10,
            marginLeft: -10,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0] === ">90D IVOL ") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <div>
          <div
            style={{ fontWeight: 100, color: "#bbb8b8" }}
          >{`-3M Premium /\n(Discount)`}</div>
        </div>
        <div
          data-tip={"The Implied Volatility Premium/Discount from 90 Days ago"}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 5,
            marginRight: -15,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (result[0].startsWith("% from Trade Range")) {
    return (
      <div>
        {result[0].endsWith("Low") ? (
          <div
            data-tip={
              "The lower boundary of Longbow's proprietary Trading Range, which is an estimated likely daily trading range for any publicly-traded security."
            }
            style={{ fontWeight: 100, color: "#bbb8b8" }}
          >
            Downside
          </div>
        ) : (
          <div
            data-tip={
              "The higher boundary of Longbow's proprietary Trading Range, which is an estimated likely daily trading range for any publicly-traded security."
            }
            style={{ fontWeight: 100, color: "#bbb8b8" }}
          >
            Upside
          </div>
        )}
      </div>
    );
  } else if (result[0].startsWith("S/T") || result[0].startsWith("M/T")) {
    return (
      <div>
        {header30DTotal === 1 && result[0].startsWith("S/T") ? (
          <div
            style={{
              color: "#bbb8b8",
              borderBottom: "1px solid #bbb8b8",
              paddingBottom: 1,
              position: "relative",
              top: -1,
            }}
          >
            Short Term
          </div>
        ) : null}
        {header90DTotal === 1 && result[0].startsWith("M/T") ? (
          <div
            style={{
              color: "#bbb8b8",
              borderBottom: "1px solid #bbb8b8",
              paddingBottom: 1,
              position: "relative",
              top: -1,
            }}
          >
            Medium Term
          </div>
        ) : null}
        {result[0].endsWith("Signal") ? (
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Signal`}</div>
        ) : (
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Price`}</div>
        )}
      </div>
    );
  } else if (result[0].startsWith("Premium")) {
    return (
      <div>
        {(headerVolatilityTotal === 1 ||
          localStorage.getItem("view") === "basic") &&
        result[0].startsWith("Premium") ? (
          <div
            style={{
              color: "#bbb8b8",
              borderBottom:
                localStorage.getItem("view") !== "basic"
                  ? "1px solid #bbb8b8"
                  : "",
              paddingBottom: 1,
              position: "relative",
              top: localStorage.getItem("view") !== "basic" ? -3 : 0,
            }}
          >
            {`Implied Volatility`}
            <br />
            {`(Discount) / Premium`}
            <div
              data-tip={`A security’s Implied Volatility Premium/(Discount) estimates whether investors are expecting greater or less certainty for a security’s price in the future. It is a ratio equal to the percent change of its Implied Volatility to Realized Volatility.  The formula = 30D ATM Put Implied Volatility divided by 30D Price Volatility minus 1.  The results are shown as of different dates.`}
              className="info-icon"
              style={{
                fontWeight: 100,
                position: "absolute",
                top: 2,
                right: -2,
                zIndex: 1,
              }}
            >
              i
            </div>
          </div>
        ) : null}

        {localStorage.getItem("view") !== "basic" ? (
          result[0].endsWith("Signal") || result[0].endsWith("Flag") ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{ fontWeight: 100, color: "#bbb8b8" }}
              >{`Signal`}</div>
              <div
                data-tip={tooltips[result[0]]}
                className="info-icon"
                style={{
                  fontWeight: 100,
                  color: "white",
                  borderColor: "white",
                  marginLeft: 5,
                }}
              >
                i
              </div>
            </div>
          ) : result[0].endsWith("Current") ? (
            <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1D`}</div>
          ) : result[0].endsWith("1D") ? (
            <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1D`}</div>
          ) : result[0].endsWith("1W") ? (
            <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1W`}</div>
          ) : result[0].endsWith("ST <30D") ? (
            <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1M`}</div>
          ) : (
            <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`3M`}</div>
          )
        ) : null}
      </div>
    );
  } else if (result[0].startsWith("Realized")) {
    return (
      // when only one realized volatility column isn't hidden, display this header format
      <div>
        {headerRealizedVolatilityTotal === 1 &&
        result[0].startsWith("Realized") ? (
          <div
            style={{
              color: "#bbb8b8",
              borderBottom: "1px solid #bbb8b8",
              paddingBottom: 1,
              position: "relative",
              top: -1,
            }}
          >
            <span>
              Realized
              <br />
              Volatility
            </span>
            <div
              data-tip={`The 30-day price volatility equals the annualized standard deviation of the 
                relative price change for the 30 most recent trading days closing price, expressed as a 
                percentage. A measure of the risk of price moves for a security calculated from the standard 
                deviation of day to day logarithmic historical price changes.`}
              className="info-icon"
              style={{
                fontWeight: 100,
                position: "absolute",
                top: "3px",
                zIndex: 1,
                right: -15,
              }}
            >
              i
            </div>
          </div>
        ) : null}
        {result[0].endsWith("Current") ? (
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1D`}</div>
        ) : result[0].endsWith("1W") ? (
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1W`}</div>
        ) : result[0].endsWith("1M") ? (
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1M`}</div>
        ) : (
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`3M`}</div>
        )}
      </div>
    );
  } else if (result[0].startsWith("Change in Realized")) {
    if (result[0].endsWith("Trade <30D"))
      result[0] = (
        <div style={{ marginRight: -65 }}>
          <div
            style={{
              borderBottomWidth: 1,
              borderBottomColor: "#707070",
              borderBottomStyle: "solid",
              width: 125,
              fontWeight: 100,
              color: "#bbb8b8",
            }}
          >{`Change in Realized`}</div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{ fontWeight: 100, color: "#bbb8b8" }}
            >{`Trade\n>1M`}</div>
            <div
              style={{ fontWeight: 100, color: "#bbb8b8" }}
            >{`Trade\n>3M`}</div>
          </div>
        </div>
      );
    else result[0] = <div style={{ marginRight: 0 }} />;
  } else if (result[0] === "Beta") {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Beta</div>
        <div
          data-tip={tooltips[result[0]]}
          className="info-icon"
          style={{
            fontWeight: 100,
            color: "white",
            borderColor: "white",
            marginLeft: 5,
          }}
        >
          i
        </div>
      </div>
    );
  } else if (
    ["1-Day ", "5-Day ", "1-Mth ", "3-Mth ", "YTD ", "ITD % Chg"].includes(
      result[0],
    )
  ) {
    result[0] = (
      <div>
        <div
          style={{
            textDecoration: "underline",
            fontWeight: 100,
            color: "#bbb8b8",
          }}
        >
          {result[0].trim() === "1-Day"
            ? " 1D "
            : result[0].trim() === "5-Day"
            ? " 1W "
            : result[0].trim() === "1-Mth"
            ? " 1M "
            : result[0].trim() === "3-Mth"
            ? " 3M "
            : result[0].trim() === "YTD"
            ? " YTD "
            : " ITD "}
        </div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`% Chg`}</div>
      </div>
    );
  } else if (["D", "1W ", "1M ", "3M ", "YY "].includes(result[0])) {
    result[0] = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div>
          <div
            style={{
              textDecoration: "underline",
              fontWeight: 100,
              color: "#bbb8b8",
            }}
          >
            {result[0] === "D"
              ? " 1D "
              : result[0] === "1W "
              ? " 1W "
              : result[0]}
          </div>
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>
            {result[0] === "D"
              ? `% Chg`
              : result[0] === "YY "
              ? `Qrtly Avg`
              : `Avg`}
          </div>
        </div>
        {result[0] !== "3M " && (
          <div
            style={{
              fontWeight: 100,
              color: "#bbb8b8",
              marginLeft: 5,
              marginRight: -10,
            }}
          >{`  vs.`}</div>
        )}
      </div>
    );
  } else if (["% Equity Float "].includes(result[0])) {
    result[0] = (
      <div>
        <div>{`% Equity`}</div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>{`Float`}</div>
          <div
            data-tip={`Short interest as a percent of equity float is a key calculation Longbow offers, defined as the quotient of Short Interest divided by Equity Float x 100.`}
            className="info-icon"
            style={{
              fontWeight: 100,
              color: "white",
              borderColor: "white",
              marginLeft: 5,
            }}
          >
            i
          </div>
        </div>
      </div>
    );
  } else if (["Vs. Last Period "].includes(result[0])) {
    result[0] = (
      <div>
        <div>{`Vs. Last`}</div>
        <div>{`Period`}</div>
      </div>
    );
  } else if (["Mth-Over-Mth "].includes(result[0])) {
    result[0] = <div>{`M/M`}</div>;
  } else if (
    [
      "Trading Range Low",
      "Trading Range High",
      "Signal Odds",
      "Core Signal Strength",
      "Range Signal",
      "<30D Momentum",
      ">90D Momentum",
      ">30D IVOL ",
    ].includes(result[0])
  ) {
    result[0] = (
      <div>
        {result[0].split(" ").map((obj) => (
          <div style={{ fontWeight: 100, color: "#bbb8b8" }}>
            {obj === "<30D"
              ? "Short Term"
              : obj === ">90D"
              ? "Medium Term"
              : obj}
          </div>
        ))}
      </div>
    );
  } else if ("<30D IVOL Premium" === result[0]) {
    result[0] = (
      <div>
        <div
          style={{ fontWeight: 100, color: "#bbb8b8" }}
        >{`Current IVOL`}</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Premium /</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Discount</div>
      </div>
    );
  } else if ("<30D 1W IVOL Premium" === result[0]) {
    result[0] = (
      <div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`1W Ago IVOL`}</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Premium /</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Discount</div>
      </div>
    );
  } else if ("<30D 3D Momentum" === result[0]) {
    result[0] = (
      <div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`3D`}</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>Momentum</div>
      </div>
    );
  } else if ("ST Momentum" === result[0]) {
    result[0] = (
      <div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Short Term`}</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8", display: "inline" }}>
          Momentum
        </div>
        <div
          data-tip={
            "The Short Term Momentum Signal reflects how a security's price has been trading on a short-term basis (30 days or less)."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 3.5,
            marginRight: -15,
            position: "relative",
            display: "inline-block",
            bottom: 1,
          }}
        >
          i
        </div>
      </div>
    );
  } else if ("-3D ST 3D Momentum" === result[0]) {
    result[0] = (
      <div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`-3D S/T`}</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8", display: "inline" }}>
          Momentum
        </div>
        <div
          data-tip={"The Short Term Momentum Signal from 3 days ago."}
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginBottom: 3.5,
            marginRight: -15,
            position: "relative",
            display: "inline-block",
            bottom: 1,
          }}
        >
          i
        </div>
      </div>
    );
  } else if ("MT Momentum" === result[0]) {
    result[0] = (
      <div>
        <div style={{ fontWeight: 100, color: "#bbb8b8" }}>{`Medium Term`}</div>
        <div style={{ fontWeight: 100, color: "#bbb8b8", display: "inline" }}>
          Momentum
        </div>
        <div
          data-tip={
            "The Medium Term Momentum Signal reflects how a security's price has been trading on a medium-term basis (less than 120 days)."
          }
          className="info-icon"
          style={{
            fontWeight: 100,
            marginLeft: 3,
            marginRight: -15,
            position: "relative",
            display: "inline-block",
            bottom: 1,
          }}
        >
          i
        </div>
      </div>
    );
  } else if ("Bullseye Alerts" === result[0]) {
    result[0] = <BullseyeAlertsModal />;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: ["Asset Class", "Description"].includes(result[0])
          ? "flex-start"
          : "center",
      }}
    >
      <div>
        <div
          style={{
            fontWeight: 100,
            color: "#bbb8b8",
            marginTop: 5,
            whiteSpace: "pre",
          }}
        >
          {result[0] === "Price" ? (
            <div style={{ display: "flex" }}>
              <div style={{ fontWeight: 100, color: "#bbb8b8" }}>
                {planInterval === "intraday" ? `Last\nPrice` : `Closing\nPrice`}
              </div>
              <div
                data-tip={
                  planInterval === "intraday"
                    ? `This is the last price checked at (${updatedDate}). Price will update daily`
                    : `This is the closing price from the last trading day (${updatedDate}). Price will update hourly.`
                }
                className="info-icon"
                style={{
                  fontWeight: 100,
                  color: "#bbb8b8",
                  borderColor: "#707070",
                  marginLeft: 3,
                  marginBottom: 5,
                  marginRight: -15,
                  position: "relative",
                  top: 20,
                }}
              >
                i
              </div>
            </div>
          ) : result[0] === ">90D IVOL " ? (
            <div>
              {/*  KISS VIEW - 3M Ago IVOL Premium/Discount */}
              90D Ago IVOL
              <div> Premium /</div>
              <div>Discount</div>
            </div>
          ) : result[0] === "Description" ? (
            <div style={{ marginLeft: 61 }}>{result[0]}</div>
          ) : (
            result[0]
          )}
        </div>
      </div>
      <span>{column.isSorted ? (column.isSortedDesc ? " ▲" : " ▼") : ""}</span>
    </div>
  );
}

export default React.memo(FormatHeader);
